import type {
  AmalgamatedBusinessAssociate,
  BusinessAssociate,
} from '@pn/core/domain/intel/business-associate';
import type {
  ApiBusinessAssociate,
  ApiNestedBusinessAssociate,
} from '@pn/services/api/intel/types';

export const apiBAMapper = {
  toDomainBusinessAssociate: (
    apiBA: ApiBusinessAssociate
  ): BusinessAssociate => {
    return {
      nid: apiBA.nid,
      province: apiBA.province,
      code: apiBA.ba_code,
      name: apiBA.provincial_company_name_pretty,
      statusEffectiveDate: apiBA.status_effective_date,
      licenceElegibilityStatus: apiBA.licence_eligibility_status,
      corporateStatus: apiBA.corporate_status,
      alamgamatedIntoBaNid: apiBA.amalgamated_into_ba_nid,
      amalgamationDate: apiBA.amalgamation_date,
      amalgamatedIntoName: apiBA.amalgamated_into_ba_name,
    };
  },
  toDomainAmalgamatedBusinessAssociate(
    apiIntel: ApiNestedBusinessAssociate
  ): AmalgamatedBusinessAssociate {
    function toDomainBusinessAssociate(
      apiAmalgamated: ApiNestedBusinessAssociate
    ): AmalgamatedBusinessAssociate {
      return {
        nid: apiAmalgamated.nid,
        province: apiAmalgamated.province,
        code: apiAmalgamated.ba_code,
        name: apiAmalgamated.provincial_company_name_pretty,
        statusEffectiveDate: apiAmalgamated.status_effective_date,
        licenceElegibilityStatus: apiAmalgamated.licence_eligibility_status,
        corporateStatus: apiAmalgamated.corporate_status,
        alamgamatedIntoBaNid: apiAmalgamated.amalgamated_into_ba_nid,
        amalgamationDate: apiAmalgamated.amalgamation_date,
        amalgamatedIntoName: apiAmalgamated.amalgamated_into_ba_name,
        amalgamatedAssociates: apiAmalgamated.amalgamated_associates.map(
          (apiBa) => toDomainBusinessAssociate(apiBa)
        ),
      };
    }

    return toDomainBusinessAssociate(apiIntel);
  },
};
